import worker from 'pdfjs-dist/webpack';
import React, { Component } from 'react';
import { pdfjs } from 'react-pdf';
import './App.css';
import { AppContextProvider } from './AppContextProvider';
import Layout from './components/Layout/Layout';
import Router from './Router';

// Import worker (recommended) : fonctionne en local, ne fonctionne pas lorsque publi�
//pdfjs.GlobalWorkerOptions.workerSrc = new URL(
//    'pdfjs-dist/build/pdf.worker.min.js',
//    import.meta.url
//).toString();
pdfjs.GlobalWorkerOptions.workerSrc = worker;

export default class App extends Component {

    render = () => <AppContextProvider>
        <Layout>
            <Router />
        </Layout>
    </AppContextProvider>;

};